import { useState } from 'react';
import { ICON_MAP, DynamicIcon } from '@/utils/iconMap';
import { Label } from '@/components/ui/label';

const ICON_OPTIONS = Object.keys(ICON_MAP);

const IconPicker = ({ value, onChange, label = '圖示' }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-1.5">
      {label && <Label>{label}</Label>}

      {/* Trigger button — shows current icon */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 border rounded-lg hover:border-primary hover:bg-primary/5 transition-colors w-full text-left"
      >
        <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
          <DynamicIcon name={value} className="h-4 w-4 text-primary" />
        </div>
        <span className="text-sm text-gray-700 flex-1">{value || '選擇圖示'}</span>
        <span className="text-xs text-muted-foreground">{open ? '▲' : '▼'}</span>
      </button>

      {/* Icon grid */}
      {open && (
        <div className="border rounded-xl p-3 bg-white shadow-md grid grid-cols-6 gap-1.5 max-h-52 overflow-y-auto">
          {ICON_OPTIONS.map((name) => {
            const isSelected = value === name;
            return (
              <button
                key={name}
                type="button"
                title={name}
                onClick={() => { onChange(name); setOpen(false); }}
                className={`flex flex-col items-center gap-1 p-2 rounded-lg transition-all hover:bg-primary/10 group ${
                  isSelected ? 'bg-primary/15 ring-1 ring-primary' : ''
                }`}
              >
                <DynamicIcon
                  name={name}
                  className={`h-5 w-5 ${isSelected ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}
                />
                <span className={`text-xs leading-tight text-center truncate w-full ${isSelected ? 'text-primary font-medium' : 'text-gray-400'}`}>
                  {name}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default IconPicker;
